import { render, staticRenderFns } from "./TransferenciasPremiosImputaciones.vue?vue&type=template&id=d9089120&"
import script from "./TransferenciasPremiosImputaciones.vue?vue&type=script&lang=js&"
export * from "./TransferenciasPremiosImputaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports